import { useCallback, useMemo } from "react";
import {
  Badge,
  Checkbox,
  ColorSwatch,
  Group,
  Paper,
  Text,
} from "@mantine/core";
import { CommunicationBypassPrefix } from "../../../services/admin/communicationSettings.service";

interface BypassPrefixOptionRowProps {
  prefix: CommunicationBypassPrefix;
  checked: boolean;
  onToggle: (prefixId: string, checked: boolean) => void;
}

export default function BypassPrefixOptionRow({
  prefix,
  checked,
  onToggle,
}: BypassPrefixOptionRowProps) {
  const handleChange = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onToggle(prefix.id, event.currentTarget.checked);
    },
    [onToggle, prefix.id]
  );
  const disabled = useMemo(
    () => !prefix.isActive && !checked,
    [checked, prefix.isActive]
  );

  return (
    <Paper p="sm" withBorder>
      <Checkbox
        checked={checked}
        disabled={disabled}
        onChange={handleChange}
        aria-label={`${checked ? "Remove" : "Select"} prefix ${prefix.code}`}
        label={
          <Group gap="xs" wrap="nowrap">
            <ColorSwatch
              color={prefix.color || "var(--mantine-color-gray-5)"}
              size={18}
              aria-label={
                prefix.color ? `${prefix.code} color` : "No color set"
              }
            />
            <Text ff="monospace" fw={700} size="sm">
              {prefix.code}
            </Text>
            <Badge
              color={prefix.isActive ? "green" : "gray"}
              variant="light"
              size="xs"
            >
              {prefix.isActive ? "Active" : "Inactive"}
            </Badge>
          </Group>
        }
      />
    </Paper>
  );
}
